import { FC } from 'react'
import SVG from 'react-inlinesvg'

interface IIcon {
  name: string
  className?: string
  width?: number
  height?: number
  fill?: string
  stroke?: string
}

const Icon: FC<IIcon> = ({ name, ...props }): JSX.Element => {
  const src = `/icons/${name}.svg`

  return <SVG src={src} {...props} />
}

export default Icon
